import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import MarisolCover from "@/assets/Img/Marisol/cover.webp";
import Sendola from "@/assets/Img/logo-sendola.png";
import Marisol from "@/assets/Icons/marisol-logo.svg";
import MarisolMockEn from "@/assets/Img/Marisol/marisol-payment-method-en.png";
import MarisolMockEs from "@/assets/Img/Marisol/marisol-payment-method-es.png";
import MarisolUser from "@/assets/Icons/marisol-user.svg";
import MarisolNumberedCard from "@/components/MarisolNumberedCard";
import { Card } from "@/components/Card";
import MarisolFeatureList from "@/components/MarisolFeatureList";
import ReceivePayroll from "@/assets/Icons/receive-payroll.svg?react";
import DebitCard from "@/assets/Icons/debid-card.svg?react";
import AtmAccess from "@/assets/Icons/atm-access.svg?react";
import Support from "@/assets/Icons/support.svg?react";
import SendolaCompatible from "@/assets/Icons/sendola-compatible.svg?react";
import { MarisolContactSection } from "@/components/MarisolContactSection";

export const MarisolPage = () => {
  const [t, i18n] = useTranslation("global");
  const lang = i18n.language;
  const featureLabels = t("Marisol.Features.Items", {
    returnObjects: true,
  }) as string[];

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) element.scrollIntoView();
    }
  }, []);

  return (
    <div className="w-full">
      <div className="relative items-center h-[16rem] md:h-[24rem] rounded-b-[24px] md:rounded-b-[80px] overflow-hidden">
        <img
          className="w-full h-full absolute top-0 left-0 object-cover"
          src={MarisolCover}
          alt="Marisol"
        />
        <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center">
          <div className="flex items-center gap-4">
            <img
              className="h-12 lg:h-24 inline object-contain"
              src={Marisol}
              alt="Marisol"
            />
            <img
              className="h-12 lg:h-16 inline object-contain"
              src={Sendola}
              alt="Sendola"
            />
          </div>

          <p className="mt-8 text-center text-white text-sm md:text-lg px-2">
            {t("Marisol.Title")}
          </p>
          <p className="text-center text-white text-sm md:text-lg px-2">
            {t("Marisol.Subtitle")}
          </p>
        </div>
      </div>

      <div className="w-full flex flex-col items-center px-6 py-2 mt-6">
        <p className="text-lg md:text-xl text-center">
          {t("Marisol.Paragraph")}
        </p>
        <p className="text-xs md:text-base text-center text-violet-600">
          {t("Marisol.Disclaimer")}
        </p>

        <div className="flex flex-col md:flex-row gap-4 mt-4 w-full justify-center md:px-12 items-stretch">
          <MarisolNumberedCard
            step={1}
            title={t("Marisol.OpenYourAccount.StepOne.Title")}
            items={t("Marisol.OpenYourAccount.StepOne.Items", {
              returnObjects: true,
            })}
          />

          <MarisolNumberedCard
            step={2}
            title={t("Marisol.OpenYourAccount.StepTwo.Title")}
            items={t("Marisol.OpenYourAccount.StepTwo.Items", {
              returnObjects: true,
            })}
            image={lang === "en" ? MarisolMockEn : MarisolMockEs}
          />
        </div>
      </div>

      <div className="w-full flex flex-col items-center px-6 py-2 mt-6">
        <Card
          className="relative w-full bg-[#f9f9f9] !rounded-3xl text-center"
          raised={false}
          rest={false}
        >
          <p className="text-xl md:text-2xl mt-8">
            {t("Marisol.Features.Title")}
          </p>

          <div className="flex flex-row mt-8 w-full justify-between px-12">
            <MarisolFeatureList
              className="justify-center items-center md:flex-nowrap md:items-baseline md:justify-between mt-8 mb-10 gap-2 lg:gap-4"
              features={[
                {
                  icon: <ReceivePayroll className="w-10 h-10" />,
                  label: featureLabels[0],
                },
                {
                  icon: <DebitCard className="w-10 h-10" />,
                  label: featureLabels[1],
                },
                {
                  icon: <AtmAccess className="w-10 h-10" />,
                  label: featureLabels[2],
                },
                {
                  icon: <Support className="w-10 h-10" />,
                  label: featureLabels[3],
                },
                {
                  icon: <SendolaCompatible className="w-10 h-10" />,
                  label: featureLabels[4],
                },
              ]}
            />
          </div>
        </Card>
      </div>

      <div className="w-full flex flex-col items-center px-6 py-2 mt-6 md:mt-20">
        <MarisolContactSection
          title={t("Marisol.Contact.Title")}
          image={MarisolUser}
        />
      </div>

      <div className="w-full flex flex-col items-center px-6 py-6 mt-6 bg-[#f9f9f9]">
        <p className="text-center text-sm md:text-base">
          {t("Marisol.Availability.Title")}
        </p>
        <p className="text-center text-xs md:text-sm pt-2">
          <span
            dangerouslySetInnerHTML={{
              __html: t("Marisol.Availability.Paragraph"),
            }}
          />
        </p>
      </div>
    </div>
  );
};
